(function ($) {

    function addAccordion() {

        const header = $(this).parent();
        const accordion = header.parent().parent();
        const current = header.parent();
        const target = header.next();
        const siblings = accordion.children().not(current);
        const siblingToggles = siblings.find('.accordion__content').not(current);

        if (target.is(':visible')) {
            target.slideUp();
        } else {
            target.slideDown();
        }
        //Är nuvarande redan öppen?


        //Stäng andra
        siblingToggles.slideUp();
    }

    $('.questions__question-title').on('click', addAccordion);
    $('.close-accordion').on('click', function () {
        $(this).parent().slideUp();
    })


})(jQuery);

jQuery(document).ready(function () {

    /*
    jQuery('.mb-jj-qa--questionlink').on( "click", function(e) {
        e.preventDefault();
        var parentHeader = jQuery( this ).closest('article')[0];
        var itemId = jQuery(parentHeader).attr('id');
        var answerblock = jQuery(parentHeader).find('.mb-jj-qa--answerblock');
        var allBlocks = jQuery('.mb-jj-qa--answerblock');
        
        jQuery(allBlocks).each(function() {
            var parentId = jQuery(jQuery( this ).closest('article')[0]).attr('id');

            if(parentId != itemId){
                jQuery( this ).hide();
            }
        });

        answerblock.toggle('fast');
    });
*/
    jQuery('#qa_query').on('keyup', function (e) {
        var query = e.target.value.toUpperCase();

        // var articleContainer = document.getElementsByClassName("mb_qa_articlelist")[0];

        var articles = document.getElementsByClassName("questions__item");
        // console.log('articles', articles);
        var countVisible = 0;
        jQuery('.mb-jj-fragaoss-noresults').hide();
        for (i = 0; i < articles.length; i++) {
            var questiontitle = articles[i].querySelector(".questions__question-title");
            var question = articles[i].querySelector(".questions__question");
            var answer = articles[i].querySelector(".questions__answer");

            var questiontitle_value = questiontitle.innerText.toUpperCase();
            var question_value = question.innerText.toUpperCase();
            var answer_value='';
            try {
                answer_value = answer.innerHTML.toUpperCase();
            } catch (error) {
                
            }

            // console.log('questiontitle_value', questiontitle_value);
            // console.log('question_value', question_value);
            // console.log('answer_value', answer_value);

            if (questiontitle_value.indexOf(query) > -1 || question_value.indexOf(query) > -1 || answer_value.indexOf(query) > -1) {
                articles[i].style.display = "";
                countVisible++;
            } else {
                articles[i].style.display = "none";
            }
        }

        if (countVisible == 0) {
            jQuery('.mb-jj-fragaoss-noresults').show();
        }
    });
});